import React from 'react';
import { render } from 'react-dom';
import { Provider } from 'react-redux';
import { sessionService } from 'redux-react-session';
import { AppContainer } from 'react-hot-loader';
import 'react-select/dist/react-select.css';
import 'react-datepicker/dist/react-datepicker.css';

import configureStore from './store/configureStore';
import App from './components/App';
import './styles/styles.scss';

// load favicons in webpack
require('../src/assets/favicon/favicon-32x32.png');
require('../src/assets/favicon/favicon-180x180.png');
require('../src/assets/favicon/favicon-192x192.png');
require('../src/assets/favicon/favicon-270x270.png');

const store = configureStore();

sessionService.initSessionService(store);

const renderApp = (Component) => {
  render(
    <Provider store={store}>
      <AppContainer>
        <Component />
      </AppContainer>
    </Provider>,
    document.getElementById('app')
  );
};

renderApp(App);

if (module.hot) {
  module.hot.accept('./components/App', () => {
    renderApp(App);
  });
}



// WEBPACK FOOTER //
// ./src/index.js